import React, { CSSProperties } from 'react'

// Styles
import './styles.scss'

export default ({
  title,
  style,
  timestamp,
}: {
  title?: string | JSX.Element
  style?: CSSProperties
  timestamp: number
}) => {
  if (!timestamp) return null

  const hours = Math.floor(timestamp / 60 / 60)
  const minutes = Math.floor(timestamp / 60) - hours * 60
  const seconds = timestamp % 60

  const formatted = [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':')

  return (
    <div className={'time-wasted'} style={style}>
      <div className={'time-wasted__title'}>
        {title ? (
          title
        ) : (
          <>
            Времени на выполнение
            <br />
            заданий затрачено
          </>
        )}
      </div>
      <div className={'time-wasted__time'}>{formatted}</div>
    </div>
  )
}
